import { css } from "styled-components";

const emSize = (pixelValue: number): string => `${pixelValue / 16}em`;

export type Breakpoints = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
};

export const BREAKPOINTS: Breakpoints = {
  xs: 375,
  sm: 768,
  md: 996,
  lg: 1200,
  xl: 1440,
};

type BreakpointValue = keyof Breakpoints;

export const min =
  (breakpoint: BreakpointValue) =>
  (...args: Parameters<typeof css>): ReturnType<typeof css> =>
    css`
      @media (min-width: ${getSizeFromBreakpoint(breakpoint, BREAKPOINTS)}) {
        ${css(...args)};
      }
    `;

export const max =
  (breakpoint: BreakpointValue) =>
  (...args: Parameters<typeof css>): ReturnType<typeof css> =>
    css`
      @media (max-width: ${getSizeFromBreakpoint(breakpoint, BREAKPOINTS)}) {
        ${css(...args)};
      }
    `;

export const getSizeFromBreakpoint = (
  breakpointValue: BreakpointValue,
  breakpoints: Breakpoints
): string => {
  if (breakpoints[breakpointValue]) {
    return emSize(breakpoints[breakpointValue]);
  } else if (parseInt(breakpointValue as string, 10)) {
    return emSize(breakpoints[breakpointValue]);
  }
  console.error(
    "styled-media-query: No valid breakpoint or size specified for media."
  );
  return "0";
};

export const larger = (
  ...args: Parameters<typeof css>
): ReturnType<typeof css> => css`
  @media (max-width: 2300px) {
    ${css(...args)};
  }
`;

export const medium = (
  ...args: Parameters<typeof css>
): ReturnType<typeof css> => css`
  @media (max-width: 1366px) {
    ${css(...args)};
  }
`;

export const smaller = (
  ...args: Parameters<typeof css>
): ReturnType<typeof css> => css`
  @media (max-width: 980px) {
    ${css(...args)};
  }
`;
